import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Field, Form, Formik } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

const Currency = (props) => {
  const [visibleCurrency, setVisibleCurrency] = useState(false);
  const [comingcurrency, setComingCurrency] = useState(
    props.visibleCurrencyChange
  );
  const [formValues, setFormValues] = useState({
    CurrencySymbol: "",
    CurrencyCode: "",
    CurrencySymbolLocation: "",
    NumberOfDecimals: "",
    ThousandsSeparator: "",
    DecimalPoint: "",
  });
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("Token");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const handleSubmit = (values) => {
    const formArray = [
      { AppConfigkey: "CurrencySymbol", AppConfigvalue: values.CurrencySymbol },
      { AppConfigkey: "CurrencyCode", AppConfigvalue: values.CurrencyCode },
      {
        AppConfigkey: "CurrencySymbolLocation",
        AppConfigvalue: values.CurrencySymbolLocation,
      },
      {
        AppConfigkey: "NumberOfDecimals",
        AppConfigvalue: values.NumberOfDecimals,
      },
      {
        AppConfigkey: "ThousandsSeparator",
        AppConfigvalue: values.ThousandsSeparator,
      },
      { AppConfigkey: "DecimalPoint", AppConfigvalue: values.DecimalPoint },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "CURRENCY",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleCurrency = () => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=CURRENCY`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "CurrencySymbol") {
            formValues.CurrencySymbol = data.AppConfigvalue;
          } else if (data.AppConfigkey === "CurrencyCode") {
            formValues.CurrencyCode = data.AppConfigvalue;
          } else if (data.AppConfigkey === "CurrencySymbolLocation") {
            formValues.CurrencySymbolLocation = data.AppConfigvalue;
          } else if (data.AppConfigkey === "NumberOfDecimals") {
            formValues.NumberOfDecimals = data.AppConfigvalue;
          } else if (data.AppConfigkey === "ThousandsSeparator") {
            formValues.ThousandsSeparator = data.AppConfigvalue;
          } else if (data.AppConfigkey === "DecimalPoint") {
            formValues.DecimalPoint = data.AppConfigvalue;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const data = [
    {
      name: "Currency Symbol:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm mb-2"
              id="CurrencySymbol"
              name="CurrencySymbol"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Currency Code:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm mb-2"
              id="CurrencyCode"
              name="CurrencyCode"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Currency Symbol Location:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-control-sm form-small select mb-2"
              id="CurrencySymbolLocation"
              name="CurrencySymbolLocation"
              onChange={handleChange}
            >
              <option>AFTER NUMBER</option>
              <option>BEFORE NUMBER</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Number Of Decimals:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-control-sm form-small select mb-2"
              id="NumberOfDecimals"
              name="NumberOfDecimals"
              onChange={handleChange}
            >
              <option>Let System Decide (Recommended)</option>
              <option>0</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Thousands Separator:",
      input: (
        <>
          {" "}
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                type="text"
                className="form-control form-control-sm mb-2"
                id="ThousandsSeparator"
                name="ThousandsSeparator"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Decimal Point:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm mb-2"
              id="DecimalPoint"
              name="DecimalPoint"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  handleCurrency();
                  setVisibleCurrency(!visibleCurrency);
                  setComingCurrency(!!comingcurrency);
                }}
              >
                Currency
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleCurrency || props.visibleCurrencyChange}>
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {() => (
                  <Form>
                    <div className="row">
                      <div
                        style={{
                          display: "flex",
                          width: "50%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "53%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>
                    </div>

                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Currency Code:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CurrencyCode"
                          name="CurrencyCode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Currency Symbol Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="CurrencySymbolLocation"
                          name="CurrencySymbolLocation"
                          onChange={handleChange}
                        >
                          <option>AFTER NUMBER</option>
                          <option>BEFORE NUMBER</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}

                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Decimals:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfDecimals"
                          name="NumberOfDecimals"
                          onChange={handleChange}
                        >
                          <option>Let System Decide (Recommended)</option>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}

                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Thousands Separator:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="ThousandsSeparator"
                          name="ThousandsSeparator"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Decimal Point:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DecimalPoint"
                          name="DecimalPoint"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleCurrency(!visibleCurrency);
                    setComingCurrency(!!comingcurrency);
                  }}
                >
                  Currency
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleCurrency || props.visibleCurrencyChange}>
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {() => (
                    <Form>
                      <div className="form-group row">
                        <div className="col-md-6">
                          {matchesSearchQuery &&
                            matchesSearchQuery?.map((el) => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "50%",
                                  alignItems: "flex-start",
                                }}
                              >
                                <label
                                  className="col-form-label"
                                  style={{ fontSize: "15px" }}
                                >
                                  {el.name}
                                </label>
                                <div>{el.input}</div>
                              </div>
                            ))}
                        </div>
                      </div>

                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Currency Code:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CurrencyCode"
                          name="CurrencyCode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Currency Symbol Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="CurrencySymbolLocation"
                          name="CurrencySymbolLocation"
                          onChange={handleChange}
                        >
                          <option>AFTER NUMBER</option>
                          <option>BEFORE NUMBER</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}

                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Decimals:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfDecimals"
                          name="NumberOfDecimals"
                          onChange={handleChange}
                        >
                          <option>Let System Decide (Recommended)</option>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}

                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Thousands Separator:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="ThousandsSeparator"
                          name="ThousandsSeparator"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Decimal Point:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DecimalPoint"
                          name="DecimalPoint"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default Currency;
